module.exports = __webpack_public_path__ + "static/media/bringFront.88757602.svg";